import { useIntl } from 'react-intl';
import { createOrdinalFromArray } from '@Util/misc.ts';

export function rangeConstraintValidator(value: string, options: { message: string; min?: number; max?: number }) {
    if (options?.min === undefined && options?.max === undefined) {
        return '';
    }

    const min = options?.min === undefined ? -Infinity : options.min;
    const max = options?.max === undefined ? Infinity : options.max;
    const valueNumber = Number(value);
    return valueNumber >= min && valueNumber <= max ? '' : options.message;
}

export function useRangeConstraintValidator() {
    const intl = useIntl();
    const defaultMessage = intl.formatMessage(
        {
            id: 'tsk_onboarding_validation_range_x_y',
        },
        createOrdinalFromArray([0, 100]),
    );
    return (value: string, options?: { message?: string; min?: number; max?: number }) =>
        rangeConstraintValidator(value, {
            message: defaultMessage,
            ...options,
        });
}
